// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__m1gC7","right":"Footer_right__2i40Y","buttons":"Footer_buttons__2SH4N"};